export default {"src":"/_next/static/media/icon-play-3.442ed0f7.svg","height":8,"width":7};